/* global $ showAlert showConfirm */
import { Controller } from 'stimulus';
import { debounce } from 'throttle-debounce';

export default class extends Controller {
  static targets = ['item', 'quantity', 'error'];

  static values = { id: Number };

  defaultErrorMessage = 'Ha ocurrido un error al actualizar.';

  initialize() {
    this.sendQuantity = debounce(1000, this.sendQuantity).bind(this);
  }

  toggleLoading(toggle) {
    const spinnerElemId = `spinner-item-${this.idValue}`;
    const spinner = document.getElementById(spinnerElemId);
    if (toggle && !spinner) {
      this.quantityTarget.parentNode.insertAdjacentHTML(
        'afterend',
        `<i id="${spinnerElemId}" class="fa fa-spinner fa-spin" style="margin: auto"></i>`
      );
    } else if (!toggle && spinner) {
      this.quantityTarget.parentNode.removeChild(spinner);
    }
  }

  resetError() {
    if (this.hasErrorTarget) {
      this.errorTarget.parentNode.removeChild(this.errorTarget);
    }
  }

  static abortController;

  sendQuantity(event) {
    const quantity = parseInt(this.quantityTarget.value, 10);

    if (Number.isNaN(quantity)) {
      return;
    }

    const method = 'PATCH';
    const body = JSON.stringify({ render_summary: true, cart: { items_attributes: { quantity, id: this.idValue } } });

    if (this.abortController) {
      this.abortController.abort(); // Cancel the previous request
    }

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.toggleLoading(true);

    fetch('/cart', {
      method,
      body,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        'Content-Type': 'application/json',
        Accept: 'text/javascript',
      },
      signal,
    })
      .then(async (response) => {
        const responseBody = await response.json();
        this.renderResult(responseBody.summary);
        if (response.ok) {
          if (event.type === 'keyup') {
            // text input (ensure the one displaying as popover)
            const input = $(`#cart-summary .cart-summary-item-input-${this.idValue}`);
            if (input.length > 0) {
              // focus the input
              input.focus();
              // and set cursor at the end
              const len = input.val().length;
              input[0].setSelectionRange(len, len);
            }
          }
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          return;
        }

        this.toggleLoading(false);
        showAlert({ message: this.defaultErrorMessage });
      });
  }

  /* eslint-disable class-methods-use-this */
  renderResult(result) {
    // refresh html for this item, cart summary total, cart icon count, the content for the source (displaying the summary again)

    if (!document.getElementById('cart-summary')) {
      // the popover is closed so update the info to display the summary again and update item count
      document.getElementById('cart-summary-info').innerHTML = result;
      const items = document.getElementById('cart-summary-info').getElementsByClassName('item').length;
      /* eslint no-param-reassign: ["error", { "props": false }] */
      [...document.getElementsByClassName('cart-items-count')].forEach((el) => {
        el.innerHTML = items.toString();
      });

      return;
    }

    const item = $(result).find(`.item[data-cart-summary-item-id-value='${this.idValue}']`);
    if (item.length === 0) {
      this.itemTarget.parentElement.remove();
    } else {
      this.itemTarget.innerHTML = item[0].innerHTML;
    }

    const items = document.getElementById('cart-summary').getElementsByClassName('item').length;

    if (items === 0) {
      $('#cart-summary').html('');
    } else {
      const total = $(result).find('.total');
      if (total.length > 0) {
        $('#cart-summary .total').html(total[0].innerHTML);
      }
    }

    /* eslint no-param-reassign: ["error", { "props": false }] */
    [...document.getElementsByClassName('cart-items-count')].forEach((el) => {
      el.innerHTML = items.toString();
    });

    document.getElementById('cart-summary-info').innerHTML = document.getElementById('cart-summary').innerHTML;
  }

  disableTarget(event) {
    const target = event.currentTarget;
    if ($(target).attr('disabled')) {
      return () => {};
    }

    $(target).attr('disabled', true);

    return () => {
      $(target).attr('disabled', false);
    };
  }

  preventPopupClose(event) {
    /* eslint-enable class-methods-use-this */
    event.preventDefault();
    event.stopPropagation();
  }

  quantityHandleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const { delta } = event.currentTarget.dataset;
    const quantity = parseInt(this.quantityTarget.value, 10) + parseInt(delta, 10);
    if (quantity > 0) {
      this.resetError();
      this.quantityTarget.value = quantity;
      this.sendQuantity(event);
    }
  }

  removeHandleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    showConfirm({
      message: '¿Está seguro que desea eliminar el producto de la lista?',
      position: 'top',
      onConfirm: () => {
        const reEnable = this.disableTarget(event);
        const method = 'DELETE';

        fetch(`/cart/items/${this.idValue}?render_summary=1`, {
          method,
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
            'Content-Type': 'application/json',
            Accept: 'text/javascript',
          },
        })
          .then(async (response) => {
            if (response.ok) {
              const responseBody = await response.json();
              this.renderResult(responseBody.summary);
              reEnable();
            }
          })
          .catch(() => {
            showAlert({ message: this.defaultErrorMessage });
          });
      },
    });
  }
}
